import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MessService } from 'src/app/_services/mess-service.service';
import { NipService } from 'src/app/_services/nip.service';
import { NipWorkerFieldsService } from '../core/nip-worker-fields.service';

@Component({
  selector: 'app-nip-worker-all-improved',
  templateUrl: './nip-worker-all-improved.component.html',
  styleUrls: ['./nip-worker-all-improved.component.scss'],
  providers: [DatePipe, MessageService],
})
export class NipWorkerAllImprovedComponent implements OnInit, OnDestroy {
  workNips: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };
  subscriptions: Subscription[] = [];
  loading = false;

  form: FormGroup;

  constructor(
    private nipsService: NipService,
    public fieldsService: NipWorkerFieldsService,
    private datePipe: DatePipe,
    private messService: MessService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      batch: '',
      product_name: '',
      product_code: '',
    });

    this.form.valueChanges.pipe(debounceTime(300)).subscribe((filters) => {
      if (filters !== null) {
        this.getAllNips(1, 10, this.createQueryString(filters));
      }
    });

    this.getAllNips();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getAllNips(pageIndex = 1, perPage = 100, queryParams = '') {
    this.loading = true;

    this.nipsService.getAllWorkNips(pageIndex, perPage, queryParams).subscribe({
      next: (responseData: any) => {
        this.workNips.data = responseData.data.map((workNip) => {
          return {
            ...workNip,
            productBatch: workNip?.product_current?.label,
            productName: workNip?.product_current?.name,
            deadline: this.datePipe.transform(workNip?.deadline, 'dd.MM.yyy'),
            colorPriority: workNip?.priority,
            workNipStatus: this.generateStatus(workNip),
          };
        });

        this.workNips.pagination = responseData.pagination;
        this.loading = false;
      },
      error: (err) => {
        if (err.status === 401) {
          this.authService.logout().subscribe(() => {
            this.router.navigate(['/login']);
          });
        }
      },
    });
  }

  onFilter() {
    const form = this.form.getRawValue();

    this.getAllNips(1, 10, this.createQueryString(form));
  }
  /* ====================================
 *                HELPERS
 ======================================= */

  onPageChange(event: any) {
    this.getAllNips(event.page + 1, event.rows);
  }

  onResetFilter() {
    this.form.patchValue({
      batch: '',
      product_name: '',
      product_code: '',
    });

    this.getAllNips();
  }

  createQueryString(form) {
    const query = new URLSearchParams(form).toString().replace('null', '');
    return query;
  }

  generateStatus(nip) {
    if (nip.active_time_tracker && !nip.active_time_tracker.end) {
      return 'Aktivan';
    }

    if (nip.active_time_tracker && nip.active_time_tracker.end) {
      return 'Stopiran';
    } else {
      return ' ';
    }
  }
}
